import { Select } from "antd";
import { useState } from "react";
import { domain, translate } from "../domain/domain";
import { IExportProfile } from "../domain/ExportProfiles/IExportProfile";

interface IProps {
    value?: string;
    onChange: (profile?: IExportProfile) => void;
}
export function ExportProfileSelector(props: IProps) {
    const [converters] = useState(domain.exportProfileService.getExportProfiles())
    function onChange(key: string) {
        const parser = converters.find(x => x.id === key);
        props.onChange(parser);
    }
    return <Select
        showSearch
        style={{ minWidth: 200 }}
        placeholder={translate("Select converter")}
        optionFilterProp="children"
        value={props.value}
        onChange={onChange}>
        {converters.map((x: IExportProfile) => (<Select.Option key={x.id} value={x.id!}>{x.name}</Select.Option>))}
    </Select>;
}
